import Drawer from './Drawer'
import DrawerHeader from './DrawerHeader'
import DrawerBody from './DrawerBody'

Drawer.Header = DrawerHeader
Drawer.Body = DrawerBody

export { DrawerHeader, DrawerBody }
export default Drawer
